<template>
  <v-app-bar app color="secondary" flat height="56">
    <v-app-bar-nav-icon
      v-if="$vuetify.breakpoint.smAndDown"
      color="primary"
      @click="$emit('toggle-drawer')"
    />

    <img src="/wais-logo-dark.png" height="34" alt="WAIS Rowing Manager" class="ml-2" style="display:block" />

    <v-spacer />

    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-btn
        v-for="item in navItems"
        :key="item.route"
        text
        :color="$route.name === item.name ? 'primary' : 'panel_primary'"
        class="mx-1"
        :to="item.route"
      >
        <v-icon small left>{{ item.icon }}</v-icon>
        {{ item.label }}
      </v-btn>
    </template>

    <v-spacer />

    <v-menu offset-y left>
      <template #activator="{ on }">
        <v-btn icon color="panel_primary" v-on="on">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-list style="background:#1e1e1e;border:1px solid #444;min-width:200px">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title style="color:#FFFFFF;font-size:0.875rem">{{ userName }}</v-list-item-title>
            <v-list-item-subtitle style="color:#EAEAEA;font-size:0.75rem;text-transform:capitalize">{{ userRole }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider style="border-color:#444" />
        <v-list-item @click="logout" style="cursor:pointer">
          <v-list-item-icon class="mr-2">
            <v-icon small style="color:#F44336">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title style="color:#F44336;font-size:0.875rem">Sign out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'NavigationBar',
  data() {
    return {
      navItems: [
        { label: 'Regattas', name: 'Regattas', route: '/regattas', icon: 'mdi-calendar-star' },
        { label: 'Results', name: 'Results', route: '/results', icon: 'mdi-podium' },
        { label: 'Lane Analysis', name: 'LaneAnalysis', route: '/lane-analysis', icon: 'mdi-chart-bar' },
        { label: 'Live Races', name: 'LiveRaces', route: '/live', icon: 'mdi-broadcast' },
        { label: 'Benchmark', name: 'BenchmarkAnalysis', route: '/benchmark', icon: 'mdi-timer-outline' },
        { label: 'Athletes', name: 'AthleteResults', route: '/athlete-results', icon: 'mdi-account-group' },
        { label: 'Splits', name: 'SplitsAnalysis', route: '/splits', icon: 'mdi-chart-timeline-variant' }
      ]
    }
  },
  computed: {
    ...mapState(['userName', 'userRole'])
  },
  methods: {
    ...mapActions(['logOut']),
    logout() {
      this.logOut()
    }
  }
}
</script>

